const Cart = () => {
  return (
    <>
      {/* <link rel="stylesheet" href="/static/assets/css/style.css" />
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.4.1/dist/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous"> */}

      <div
        className="modal fade"
        id="customermodal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-body">
              <div className="row">
                <div className="col-12 border-bottom">
                  <div className="row pb-3">
                    <div className="col-4">
                      <button
                        className="btn btn-default border"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                    <div className="col-4">
                      <div style="position:relative" className="float-left">
                        <input
                          type="text"
                          className="search-item ml-3"
                          placeholder="Search Customer..."
                        />
                        <i
                          className="fa fa-search   srch-icon"
                          aria-hidden="true"
                        ></i>
                        <i
                          className="fa fa-times  cross-icon"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div className="col-4">
                      <button className="btn db float-left">
                        Set Customer
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-12 border-bottom mt-3">
                  <div className="row">
                    <div className="col-10">
                      <img
                        style="width: 50px;"
                        src="/static/assets/img/pp.png"
                      />
                      <span style="font-size: 25px;margin-left: 15px;">
                        Customer ABC
                      </span>
                    </div>

                    <div className="col-2">
                      <a href="">
                        <img
                          style="width: 30px;"
                          src="/static/assets/img/edit.svg"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-6">
                      <div className="row">
                        <div className="col-4">Address:</div>
                        <div className="col-8">
                          123 Lal Street Lal Bazar 190023
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="row">
                        <div className="col-4">Barcode:</div>
                        <div className="col-8">N/A</div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="row">
                        <div className="col-4">Email:</div>
                        <div className="col-8">example@example.com</div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="row">
                        <div className="col-4">Tax Id:</div>
                        <div className="col-8">N/A</div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="row">
                        <div className="col-4">Phone:</div>
                        <div className="col-8">+91 99065 76376</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 py-0 mt-3">
                  <table className="table  table-striped ">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Name</th>
                        <th>Name</th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div className="col-12 " style="overflow:scroll;height:300px;">
                  <table className="table table-striped ">
                    <tbody>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                      <tr>
                        <td>Mark Azure</td>
                        <td>123 Lal Street Lal Bazar 190023</td>
                        <td>+91 99065 76376</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="tophead" className="fixed-top">
        <div className="container-fluid">
          <div
            className="row"
            style="background: linear-gradient(237deg, #2197D6, #0000A2, #8016BE);"
          >
            <div className="col-lg-4 topper-section l-sect">
              <div className="logo-container">
                <img src="/static/assets/img/logo.png" alt="" />
                <span className="apps ml-3 mt-2">Pos Cart</span>
              </div>
            </div>
            <div className="col-lg-5 topper-section m-sect">
              <div
                className="order-sect  float-left"
                data-toggle="modal"
                data-target="#ordersmodal"
                style="cursor:pointer"
              >
                <i className="fa fa-ticket">
                  <span className="badge badge-info count-badge">2</span>
                </i>
                <span className="ml-2">Order</span>
              </div>
              <div className=" inp-sect float-left ">
                <input
                  type="text"
                  className="search-item ml-3"
                  placeholder="Search Here..."
                />
                <i className="fa fa-search   srch-icon" aria-hidden="true"></i>
                <i className="fa fa-times  cross-icon" aria-hidden="true"></i>
              </div>
            </div>
            <div className="col-lg-3 topper-section ">
              <div className="d-flex justify-content-end mt-3">
                {/* <span className="mr-4">{{request.user.first_name}} {{request.user.last_name}}</span> */}
                <i
                  className="fa fa-wifi mt-1 mr-4 wifi-icons"
                  aria-hidden="true"
                ></i>
                <a href="/pos" className="close-label">
                  {" "}
                  <span className="tex-white">Close</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="section">
        <div className="container-fluid">
          <div className="row">
            <div id="left1">
              <div style="height: 52%;" className="c-basket">
                <div id="hide-kart" className="">
                  <i
                    className="fa fa-shopping-cart  shop-kart"
                    aria-hidden="true"
                  ></i>{" "}
                  <br />
                  <div>
                    <h3 className="tagged-line">This Order is Empty</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-11 p-2  order-container mt-4 con-hide">
                    <ul className="ordered-container">
                      <li className="order-list">
                        <span className="product-name">Appy</span>
                        <br />
                        <span className="product-price">1.5</span>
                        <div className="item-total">
                          <span className="ttl-amt">
                            <i className="fa fa-inr mr-1"></i>
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="row p-4">
                <div className="col-5  p-0">
                  <div
                    className="customer "
                    data-toggle="modal"
                    data-target="#customermodal"
                    style="cursor:pointer"
                  >
                    <i
                      className="fa fa-user-circle-o usr-icon"
                      aria-hidden="true"
                    ></i>
                    <span>Customer</span>
                  </div>
                  <div
                    className="payment"
                    data-toggle="modal"
                    data-target="#paymentsmodal"
                    style="cursor:pointer"
                  >
                    <i
                      className="fa fa-chevron-circle-right  arr-pay"
                      aria-hidden="true"
                    ></i>
                    <div>
                      <h5 className="payment-line">Payment</h5>
                    </div>
                  </div>
                </div>

                <div className="col-7  p-0 m-0 button-section">
                  <button className="btn-num btm-none" id="gonn">
                    1
                  </button>
                  <button className="btn-num btm-none">2</button>
                  <button className="btn-num btm-none">3</button>
                  <button className="btn-num btm-none brr">Qty</button>
                  <button className="btn-num btm-none">4</button>
                  <button className="btn-num btm-none">5</button>
                  <button className="btn-num btm-none">6</button>
                  <button className="btn-num btm-none">Disc</button>
                  <button className="btn-num btm-none">7</button>
                  <button className="btn-num btm-none">8</button>
                  <button className="btn-num btm-none">9</button>
                  <button className="btn-num btm-none">Price</button>
                  <button className="btn-num">+/-</button>
                  <button className="btn-num">0</button>
                  <button className="btn-num">.</button>
                  <button className="btn-num brr2">
                    <i className="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>

            <div id="right1">
              <div
                className="d-flex px-5 m-0 w-100 py-1"
                style="position:fixed;overflow-y: hidden;overflow-x: scroll;z-index: 100;background-color:#eee;top:60"
              >
                <ul className="nav nav-pills mt-3 px-0">
                  <li className="nav-item">
                    <a className="nav-link active" href="#">
                      Active
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Link
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Link
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link disabled">Disabled</a>
                  </li>
                </ul>
              </div>
              <div className="container-fluid ">
                <div
                  className="row d-flex justify-content-center "
                  style="margin-top: 140px;"
                >
                  {/* {% for d in products %} */}
                  <div
                    className=" tagged-container p-0 m-2"
                    data-name="{{d.ProductName}}"
                    data-price="{{d.SalesPrice}}"
                    data-id="{{d.id}}"
                    style="width:135;height:147px"
                  >
                    <div className="img-container">
                      <img
                        src="/media/{{d.Photo}}"
                        alt=""
                        className="img-fluid"
                      />
                      <div className="mt-1 tag-name">
                        {/* <span style="font-size: 12px; font-weight: bold;" className="itm-val">{{d.ProductName}}</span> */}
                      </div>
                      <span className="badge badge-success bdg-span">
                        <i className="fa fa-inr mr-1"></i>
                        {/* {{d.SalesPrice}}/Units */}
                      </span>
                    </div>
                  </div>
                  {/* {% endfor %} */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="ordersmodal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel2"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 border-bottom">
                    <div className="row pb-3">
                      <div className="col-6">
                        <button className="btn db ">New Order</button>
                        <button
                          className="btn btn-default border"
                          data-dismiss="modal"
                        >
                          Discard
                        </button>
                      </div>
                      <div className="col-6">
                        <div style="position:relative" className="float-left">
                          <input
                            type="text"
                            className="search-item ml-3"
                            placeholder="Search Tickets..."
                          />
                          <i
                            className="fa fa-search   srch-icon"
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 py-0 mt-3">
                    <table className="table  table-striped ">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th
                            style="
                    text-align: center;
                "
                          >
                            Receipt Number
                          </th>
                          <th
                            style="
                    text-align: -webkit-center;
                "
                          >
                            Customer
                          </th>
                          <th>Employee</th>
                          <th>Total</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div
                    className="col-12 "
                    style="overflow:scroll;height:300px;"
                  >
                    <table className="table table-striped ">
                      <tbody>
                        <tr>
                          <td>2021-11-24 01:08 PM</td>
                          <td>Order 00001-001-0001</td>
                          <td>CustomerABC</td>
                          <td>Mitchell Admin</td>
                          <td>₹ 0.00</td>
                          <td
                            style="
                    text-align: center;"
                          >
                            Ongoing
                          </td>
                          <td>
                            <i className="fa fa-trash" aria-hidden="true"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="paymentsmodal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel3"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 border-bottom">
                    <div className="row pb-3">
                      <div className="col-4">
                        <button
                          className="btn btn-default border"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                      <div style="text-align: center;" className="col-4">
                        <span style="font-size: x-large;">Payment</span>
                      </div>
                      <div className="col-4 ">
                        <button className="btn db float-right">Validate</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <div
                      style="padding: 20px; background: #e2e2e2;border: solid 1px rgb(202, 202, 202);"
                      className="col-12 mt-3"
                    >
                      <b>Cash</b>
                    </div>
                    <div
                      style="padding: 20px ;background: #e2e2e2;border: solid 1px rgb(202, 202, 202);"
                      className="col-12 "
                    >
                      <b>Bank</b>
                    </div>
                  </div>
                  <div className="col-8 border-left">
                    <div className="col-12" style="text-align: center;">
                      <span className="grd">₹ 0.00</span>
                    </div>
                    <div className="text-center ">
                      <span>Please select a payment method.</span>
                    </div>
                    <div className="row mt-2 border-bottom">
                      <div className="col-6">
                        <div>
                          <span style="font-size: 25px;">Remaining ₹ 0.00</span>
                        </div>
                        <div>
                          <span>Total Due ₹ 0.00</span>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="float-right">
                          <span style="font-size: 25px;">Change</span>
                          <span className="grd" style="font-size: 25px;">
                            {" "}
                            ₹ 1.00
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6 p-0 m-0 button-section">
                        <div
                          style={{ width: "70%", margin: "23px 0px 3px 55px" }}
                        >
                          <button className="btn-num btm-none" id="gonn">
                            1
                          </button>
                          <button className="btn-num btm-none">2</button>
                          <button className="btn-num btm-none">3</button>
                          <button className="btn-num btm-none brr">+10</button>
                          <button className="btn-num btm-none">4</button>
                          <button className="btn-num btm-none">5</button>
                          <button className="btn-num btm-none">6</button>
                          <button className="btn-num btm-none">+20</button>
                          <button className="btn-num btm-none">7</button>
                          <button className="btn-num btm-none">8</button>
                          <button className="btn-num btm-none">9</button>
                          <button className="btn-num btm-none">+50</button>
                          <button className="btn-num">+/-</button>
                          <button className="btn-num">0</button>
                          <button className="btn-num">.</button>
                          <button className="btn-num brr2">
                            <i className="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                      <div className="col-6 mt-2">
                        <div
                          style="padding: 20px; background: #e2e2e2;border: solid 1px rgb(202, 202, 202);"
                          className="col-12 mt-3"
                        >
                          <div className="row">
                            <div style="margin-left: 15px; border: solid 2px rgb(202, 202, 202);border-radius: 26px;width: 40px;height: 40px;">
                              <i
                                style="margin-left: 12px;margin-top: 8px;"
                                className="fa fa-user"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div style="margin-top: 10px;margin-left: 80px;">
                              <b>Customer</b>
                            </div>
                          </div>
                        </div>
                        <div
                          style="padding: 20px; background: #e2e2e2;border: solid 1px rgb(202, 202, 202);"
                          className="col-12 mt-3"
                        >
                          <div className="row">
                            <div style="margin-left: 15px; border: solid 2px rgb(202, 202, 202);border-radius: 26px;width: 40px;height: 40px;">
                              <i
                                style="margin-left: 12px;margin-top: 8px;"
                                className="fa fa-file-text-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div style="margin-top: 10px;margin-left: 80px;">
                              <b>Invoice</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js"
  integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous">
</script>

<script src="/static/assets/js/custom.js" type="text/javascript"></script> */}
    </>
  );
};
export default Cart;
